import type { OrderStore } from './interfaces'

export const actions = {
  setOrder (this: OrderStore, payload: OrderStore['order']): void {
    this.order = payload
  },
  setChangelogPayment (this: OrderStore, payload: OrderStore['changelogPayment']): void {
    this.changelogPayment = payload
  },
}
